import BasePage from './LazyBasePage';
import { runSearch } from '../redux/search/actions';
import { connect } from 'react-redux';

const _mapStateToProps = ({ app, user, content }, ownProps) => ({
    ...ownProps,
    isMobile: app.isMobile,
    isAuthenticated: user.isAuthenticated,
    userId: user.publicId,
    featureFlags: app.featureFlags,
    seasonalContent: content.seasonal,
});

const _mapDispatchToProps = {
    handleSearch: runSearch,
};

export default connect(_mapStateToProps, _mapDispatchToProps)(BasePage);
